import { Store } from '@webtides/element-js';

/**
 * @property {boolean} isIntersecting
 */
export default class IntersectionStore extends Store {
    _intersectionObserver;

    properties() {
        return {
            isIntersecting: false,
        };
    }

    /**
     * @param {IntersectionObserverInit} options
     */
    constructor(
        options = {
            rootMargin: '0px',
            threshold: 0,
        },
    ) {
        super();
        this._intersectionObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                this.isIntersecting = entry.isIntersecting;
            });
        }, options);
    }

    /**
     * @param {Element} target
     */
    observe(target) {
        this._intersectionObserver.observe(target);
    }
}
